/* eslint-disable */
// All ESLint errors will be ignored in this file

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import LogIn from '../LogIn/index';
import SingleAccountResearchApp from '../ResearchPage/account/single/index';
import BulkAccountResearchPage from '../ResearchPage/account/bulk/index';
import ContactResearchPage from '../ResearchPage/contact/single/index';
import LookalikeResearchPage from '../ResearchPage/lookalike/single/index';
import TechStackResearchPage from '../ResearchPage/tech_stack/single/index';
import AttributionPage from '../AttributionPage/index';
import IntegrationPage from '../IntegrationPage/index';
import PlatformIntegration from '../IntegrationPage/PlatformIntegration';
import CompaniesPage from '../ProspectInfoPages/CompaniesPage';
import ContactsPage from '../ProspectInfoPages/ContactsPage';
import RedirectPage from '../IntegrationPage/RedirectPage';
import SignupPage from '../SignupPage';
import EmailConfirmation from '../EmailConfirmation';
import ProtectedRoute from '../../components/ProtectedRoute';

const WrappedRoutes = (props) => {
  return (
    <div>
      <Layout />
      <div className="container__wrap">
        <Switch>
          <Route path="/research/account/single" component={SingleAccountResearchApp} />
          <Route exact path="/research/account" component={SingleAccountResearchApp} />

          <Route path="/research/contact/single" component={ContactResearchPage} />
          <Route exact path="/research/contact" component={ContactResearchPage} />
          <Route path="/find/lookalike" component={LookalikeResearchPage} />
          <Route path="/find/tech-stack" component={TechStackResearchPage} />

          {/* Make SingleAccountResearchApp the default for exact path "/" */}
          <Route exact path="/" component={SingleAccountResearchApp} />
        </Switch>
      </div>
    </div>
  );
};

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/login" component={LogIn} />
        <Route exact path="/signup" component={SignupPage} />
        <Route exact path="/confirm-email" component={EmailConfirmation} />
        <ProtectedRoute path="/" component={WrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
